import { render, staticRenderFns } from "./DialogBg.vue?vue&type=template&id=216c555d&scoped=true"
import script from "./DialogBg.vue?vue&type=script&lang=js"
export * from "./DialogBg.vue?vue&type=script&lang=js"
import style0 from "./DialogBg.vue?vue&type=style&index=0&id=216c555d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c555d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216c555d')) {
      api.createRecord('216c555d', component.options)
    } else {
      api.reload('216c555d', component.options)
    }
    module.hot.accept("./DialogBg.vue?vue&type=template&id=216c555d&scoped=true", function () {
      api.rerender('216c555d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogBg.vue"
export default component.exports